import type { FC } from 'react';
import clsx from 'clsx';

import { TimerLevel } from 'store/conference/events/attachTimerMessageReceivedEvent';
import { useTimerStore } from 'store/timer';

import { useTimer } from '../hooks/useTimer';
import styles from '../styles.module.scss';

const Time: FC = () => {
    const { availableTime, timerConfig } = useTimerStore();
    const time = useTimer();
    // таймер дошел до уровня предупреждения
    const isAlmostOver = (timerConfig?.[TimerLevel.TWO] ?? 0) > (availableTime ?? 0);

    return <span className={clsx(styles.time, { [styles.timeIsAlmostOver]: isAlmostOver })}>{time}</span>;
};

export default Time;
